import { render, staticRenderFns } from "./RelaxationRoom.vue?vue&type=template&id=24699b74&scoped=true&"
import script from "./RelaxationRoom.vue?vue&type=script&lang=js&"
export * from "./RelaxationRoom.vue?vue&type=script&lang=js&"
import style0 from "./relaxation-room.css?vue&type=style&index=0&id=24699b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24699b74",
  null
  
)

export default component.exports